import ReactGA from 'react-ga';

const TRACK_ID = 'UA-117842856-2';

export const pageview = page => {
    try {
        if (window.cordova && window.ga) {
            console.log('trackview', window.ga, page);
            window.ga.trackView(page);
        } else {
            console.log('pageview', page);
            ReactGA.pageview(page);
        }
    } catch (e) {}
};

if (window.cordova) {
    document.addEventListener('deviceready', function() {
        try {
            console.log('start tracking');
            window.ga.startTrackerWithId(TRACK_ID);
        } catch (e) {}
    });
} else {
    ReactGA.initialize(TRACK_ID);
}



// WEBPACK FOOTER //
// ./src/GA.js